<ng-container *ngIf="facebookConfiguration">
  <sidenav-content-header
    [title]="!isCreatingNewForm ? 'Facebook form ID ' + facebookConfiguration.formId : 'Crea Form'"
    (close)="onCloseClick()">

  </sidenav-content-header>


  <mat-tab-group *ngIf="(user$ | async | hasPermission:userPermission.ViewFacebookLogs); else onlyDetails">

    <mat-tab label="Dettagli">
      <app-sidenav-content-facebook-form-info [formInfo]="facebookConfiguration"
        [readOnly]="!(user$ | async | hasPermission:userPermission.EditFacebookFormConfig)"
        [canDelete]="(user$ | async | hasPermission:userPermission.DeleteFacebookFormConfig)" (close)="onCloseClick()">
      </app-sidenav-content-facebook-form-info>
    </mat-tab>

    <mat-tab label="Logs">
      <app-sidenav-content-facebook-form-logs [formConfiguration]="facebookConfiguration">
      </app-sidenav-content-facebook-form-logs>
    </mat-tab>

  </mat-tab-group>

  <ng-template #onlyDetails>

    <app-sidenav-content-facebook-form-info [formInfo]="facebookConfiguration"
      [readOnly]="!(user$ | async | hasPermission:userPermission.EditFacebookFormConfig)"
      [canDelete]="(user$ | async | hasPermission:userPermission.DeleteFacebookFormConfig)" (close)="onCloseClick()">
    </app-sidenav-content-facebook-form-info>

  </ng-template>

</ng-container>
